export const getCurrentDateTime = (): Date => new Date(Date.now());
